import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';

@Injectable({
  providedIn: 'root',
})
export class SystemService {
  constructor(private common: CommonService) {
  }

  /**
   * 获取更新通知状态
   */
  async getUpdate(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.common.ajax({
        url: 'system/tool/getViewRecord',
        loading: true,
        success: (res) => {
          resolve(res);
        },
      });
    });
  }

  /**
   * 更新通知状态
   */
  async updateStatus(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.common.ajax({
        url: 'system/tool/editRecord',
        type: 'post',
        loading: true,
        success: (res) => {
          resolve(res);
        },
      });
    });
  }

  /**
   * 获取更新日志 分页列表
   */
  async getUpdateLog(params: object): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.common.ajax({
        url: 'V2/system/upgrade/getList',
        data: params,
        loading: true,
        success: res => {
          resolve(res);
        },
      });
    })
      ;
  }

  /**
   * 获取最新的更新公告
   */
  async getNewUpdateLog(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.common.ajax({
        url: 'V2/system/upgrade/getNewEdition',
        data: {},
        loading: true,
        success: res => {
          resolve(res);
        },
      });
    })
      ;
  }
}
